module.exports = __webpack_public_path__ + "static/media/manLogo.1cea7186.svg";